const base = "w-full rounded-xl border bg-white px-4 py-3.5 text-[15px] text-ink placeholder:text-ink/45 outline-none transition-[border-color,box-shadow] duration-200 focus:border-forest focus:ring-4 focus:ring-forest/10";

const Label = ({ id, label, required, optional }) => (
  <label htmlFor={id} className="mb-2 block text-sm font-medium text-ink">
    {label}{required && " *"}{optional && <span className="font-normal text-ink/60"> (opcional)</span>}
  </label>
);

const Err = ({ id, error }) => (error ? <p id={id} role="alert" className="mt-1.5 text-sm text-red-700">{error}</p> : null);

export const Field = ({ name, label, error, required, optional, textarea, className = "", ...rest }) => {
  const id = `f-${name}`;
  const props = {
    id, name, "aria-invalid": !!error, "aria-describedby": error ? `${id}-err` : undefined, "aria-required": required || undefined,
    "data-testid": `quote-input-${name}`, className: `${base} ${error ? "border-red-400" : "border-forest/15"}`, ...rest,
  };
  return (
    <div className={className}>
      <Label id={id} label={label} required={required} optional={optional} />
      {textarea ? <textarea rows={4} {...props} /> : <input {...props} />}
      <Err id={`${id}-err`} error={error} />
    </div>
  );
};

export const SelectField = ({ name, label, options, error, required, optional, className = "", ...rest }) => {
  const id = `f-${name}`;
  return (
    <div className={className}>
      <Label id={id} label={label} required={required} optional={optional} />
      <select id={id} name={name} aria-invalid={!!error} aria-describedby={error ? `${id}-err` : undefined} data-testid={`quote-select-${name}`}
        className={`${base} appearance-none bg-[url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' fill='none'%3E%3Cpath d='M1 1.5l5 5 5-5' stroke='%230A2E20' stroke-width='1.6'/%3E%3C/svg%3E")] bg-[length:12px] bg-[right_1rem_center] bg-no-repeat pr-10 ${error ? "border-red-400" : "border-forest/15"}`} {...rest}>
        <option value="">Selecione…</option>
        {options.map((o) => <option key={o} value={o}>{o}</option>)}
      </select>
      <Err id={`${id}-err`} error={error} />
    </div>
  );
};
